export const SPORT_ICONS = {
    athletics: 'custom-athletics',
    badminton: 'badminton-shuttlecock',
    basketball: 'basketball-ball',
    cricket: 'cricket-bat-ball',
    esports: 'video-game-xbox-controller',
    football: 'soccer-ball',
    futsal: 'custom-futstal',
    gaa: 'custom-gaelic-football',
    golf: 'golf-ball',
    gym: 'fitness-dumbbell',
    handball: 'custom-handball',
    hockey: 'custom-hockey',
    lacrosse: 'custom-lacrosse',
    netball: 'custom-netball',
    quidditch: 'custom-quidditch',
    rugby: 'custom-rugby',
    'space-hire': 'custom-space-hire',
    squash: 'custom-squash',
    swimming: 'swimming-pool-stairs',
    'table-tennis': 'ping-pong-paddle',
    tennis: 'custom-tennis',
    volleyball: 'volleyball-ball',
    'american-football': 'american-football-helmet',
    'padel-tennis': 'custom-padel',
};
